export default __webpack_public_path__ + "static/media/photo--lg--15.3a383963.jpg";